import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ShopLocationDropdownComponent } from './shop-location-dropdown.component';
import { AppContentOverlayModule } from '../content-overlay/content-overlay.module';
import { AppMultipleFilterModule } from '../app-multiple-filter/app-multiple-filter.module';

@NgModule({
  imports: [CommonModule, RouterModule, AppContentOverlayModule, AppMultipleFilterModule],
  declarations: [ShopLocationDropdownComponent],
  exports: [ShopLocationDropdownComponent],
})
export class ShopLocationDropdownModule {}
